import React from 'react';
import { motion } from 'framer-motion';
import PageHeader from '../../components/common/PageHeader';

const MontessoriFacilities = () => {
  const facilities = [
    {
      name: 'Montessori Classrooms',
      description: 'Spacious, well-lit classrooms with age-appropriate Montessori materials and furniture.',
      image: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=600&h=400&fit=crop',
    },
    {
      name: 'Outdoor Play Area',
      description: 'Safe, secure playground with modern equipment for physical development and social play.',
      image: 'https://images.unsplash.com/photo-1544485779-fa75d0e4abf9?w=600&h=400&fit=crop',
    },
    {
      name: 'Library Corner',
      description: 'Cozy reading spaces with a wide selection of age-appropriate books and learning materials.',
      image: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=600&h=400&fit=crop',
    },
    {
      name: 'Music & Art Room',
      description: 'Dedicated space for creative expression through music, art, and craft activities.',
      image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=400&fit=crop',
    },
    {
      name: 'Dining Hall',
      description: 'Clean, child-friendly dining area where nutritious meals are served.',
      image: 'https://images.unsplash.com/photo-1567521464027-f127ff144326?w=600&h=400&fit=crop',
    },
    {
      name: 'Sick Bay',
      description: 'On-site medical facility with trained staff for minor health needs.',
      image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&h=400&fit=crop',
    },
  ];

  return (
    <>
      <PageHeader
        title="Facilities"
        subtitle="Safe, nurturing spaces designed for young learners"
        breadcrumbs={[
          { label: 'Our Schools', href: '/our-schools' },
          { label: 'Montessori & Primary', href: '/montessori' },
          { label: 'Facilities' },
        ]}
      />

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {facilities.map((facility, index) => (
              <motion.div
                key={facility.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group"
              >
                <div className="relative h-56 rounded-2xl overflow-hidden mb-4">
                  <img
                    src={facility.image}
                    alt={facility.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{facility.name}</h3>
                <p className="text-gray-600">{facility.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MontessoriFacilities;
